import CertificateHeroSection from "./CertificateHeroSection"
import AvailableCertifications from "./AvailableCertifications"
import EarnedCertificatesSection from "./EarnedCertificatesSection";

const CertificatePage = () => {
  return (
    <div>
      <CertificateHeroSection />
      <EarnedCertificatesSection />
      <AvailableCertifications />
    </div>
  )
}

export default CertificatePage;
